import axios from "axios"

const api = axios.create({
    timeout: 25000,
    timeoutErrorMessage: 'Request timed out',
    insecureHTTPParser: true,
})

export default api